module.exports = __webpack_public_path__ + "static/feeb-21c744ba0e4f1e8ebf1bf35c1672292e.png";